export default "__VITE_ASSET__BjDybF8K__"